// src/redux/gameSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LetterState = "correct" | "present" | "absent";

interface GameState {
  answer: string;
  guesses: string[];
  results: LetterState[][];
  currentGuess: string;
  gameStatus: "playing" | "won" | "lost";
  attempt: number;
  loading: boolean;
}

const initialState: GameState = {
  answer: "",
  guesses: [],
  results: [],
  currentGuess: "",
  gameStatus: "playing",
  attempt: 0,
  loading: true,
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    setAnswer: (state, action: PayloadAction<string>) => {
      state.answer = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    typeLetter: (state, action: PayloadAction<string>) => {
      if (state.currentGuess.length < 5 && state.gameStatus === "playing") {
        state.currentGuess += action.payload.toUpperCase();
      }
    },
    deleteLetter: (state) => {
      if (state.gameStatus === "playing") {
        state.currentGuess = state.currentGuess.slice(0, -1);
      }
    },
    submitGuess: (state, action: PayloadAction<LetterState[]>) => {
      if (state.gameStatus !== "playing") return;
      if (state.currentGuess.length !== 5) return;

      state.guesses.push(state.currentGuess);
      state.results.push(action.payload);
      state.attempt += 1;

      if (state.currentGuess === state.answer) {
        state.gameStatus = "won";
      } else if (state.attempt >= 6) {
        state.gameStatus = "lost";
      }

      state.currentGuess = "";
    },
    resetGame: (state) => {
      state.guesses = [];
      state.results = [];
      state.currentGuess = "";
      state.gameStatus = "playing";
      state.attempt = 0;
      state.loading = false;
    },
  },
});

export const {
  setAnswer,
  setLoading,
  typeLetter,
  deleteLetter,
  submitGuess,
  resetGame,
} = gameSlice.actions;

export default gameSlice.reducer;
